import { Route, Routes } from 'react-router-dom';
import { ShareholdersMeetingsRoutes } from '../shareholders-meetings/ShareholdersMeetings';
import { BoardMeetingsRoutes } from '../board-meetings/BoardMeetings';
import { AuthorizationsRoutes } from '../authorizations/Authorizations';
import { ArticlesOfAssocsRoutes } from '../articles-of-assocs/ArticlesOfAssocs';

export const BoardPortal = () => {
  return (
    <Routes>
      <Route path="shareholders-meetings" element={<ShareholdersMeetingsRoutes />}>
        <Route path="*" element={<ShareholdersMeetingsRoutes />} />
      </Route>
      <Route path="board-meetings" element={<BoardMeetingsRoutes />}>
        <Route path="*" element={<BoardMeetingsRoutes />} />
      </Route>
      <Route path="authorization-groups" element={<AuthorizationsRoutes />}>
        <Route path="*" element={<AuthorizationsRoutes />} />
      </Route>
      <Route path="articles-of-assocs" element={<ArticlesOfAssocsRoutes />}>
        <Route path="*" element={<ArticlesOfAssocsRoutes />} />
      </Route>
      <Route path="" element={<>404</>} />
    </Routes>
  );
};
